import clsx from 'clsx'
import startsWith from 'lodash/startsWith'
import React, { FC, useEffect, useRef, useState } from 'react'

import { SpecificationsItemReference } from '@Components/Product/Specifications/Item/Reference'
import {
  isProductSpecificationGroupItemMultiple,
  isProductSpecificationGroupItemReference,
  isProductSpecificationGroupItemText,
  isProductSpecificationGroupItemUnit,
} from '@Components/Product/Specifications/types'
import { ProductSpecificationItemWithMultiple } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './SpecificationsItem.module.scss'

export interface SpecificationsItemProps {
  specification: ProductSpecificationItemWithMultiple
}

export const SpecificationsItem: FC<SpecificationsItemProps> = ({ specification }) => {
  const { t } = useTranslation()
  const [truncate, setTruncate] = useState(true)
  const [overwriteTruncate, setOverwriteTruncate] = useState(false)
  const refWrapper = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (refWrapper?.current && !overwriteTruncate && truncate) {
      setTruncate(refWrapper.current.scrollHeight > 50)
    }
  }, [overwriteTruncate, refWrapper, truncate])

  return (
    <div className={styles.specWrapper}>
      <span className={styles.spec}>{specification.name}</span>
      <span className={styles.spec}>
        <span className={clsx(styles.truncatedText, truncate && styles.truncate)} ref={refWrapper}>
          {isProductSpecificationGroupItemMultiple(specification) && specification.items?.map(item => (
            <p key={item.name}>
              {specification.items?.length !== 1 && item.name && !startsWith(item.name, 'hide---') && (
                <>
                  {item.name}
                  {': '}
                </>
              )}
              {isProductSpecificationGroupItemText(item) && item.text}
              {isProductSpecificationGroupItemUnit(item) && item.format}
              {isProductSpecificationGroupItemReference(item) && <SpecificationsItemReference specification={item} />}
            </p>
          ))}
          {isProductSpecificationGroupItemText(specification) && specification.text}
          {isProductSpecificationGroupItemUnit(specification) && specification.format}
          {isProductSpecificationGroupItemReference(specification) && <SpecificationsItemReference specification={specification} />}
        </span>

        {(truncate || overwriteTruncate) && (
          <span
            className={styles.moreLess}
            onClick={() => {
              setTruncate(!truncate)
              setOverwriteTruncate(true)
            }}
          >
            {truncate ? t('cms:SHOW_MORE_LABEL', 'Show more') : t('cms:SHOW_LESS_LABEL', 'Show less')}
          </span>
        )}
      </span>
    </div>
  )
}
